import { BlobDto, ImageApi } from "../Repository/eventbookyapi";
import { GetApiConfiguration } from "./ServiceConfiguration";

export abstract class DocumentService {
    public static GetImage = async (url: string) => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include' as RequestCredentials
        };
        return await fetch(process.env.REACT_APP_API_URL + '/Image/downloadImage?bloburl=' + url, requestOptions);
    };

    public static GetFile = async (url: string) => {
        return new ImageApi(GetApiConfiguration()).apiImageDownloadFileGetRaw({
            bloburl: url
        });
    };

    public static GetBannerImages = async () => {
        return new ImageApi(GetApiConfiguration()).apiImageGetimagesGet();
    };

    public static GetPublicImages = async () => {
        return new ImageApi(GetApiConfiguration()).apiImageGetCompanyPublicImagesGet();
    };

    public static UploadPublicImage = async () => {
        return new ImageApi(GetApiConfiguration()).apiImageUploadPublicImagePost();
    };


    public static GetBackupFiles = async () => {
        return new ImageApi(GetApiConfiguration()).apiImageGetbackupsGet();
    };

    public static DeleteBannerImage = async (blobUri: string) => {
        return new ImageApi(GetApiConfiguration()).apiImageDeleteImageDelete({
            bloburl: blobUri
        });
    };

    public static DeletePublicImage = async (blobUri: string) => {
        return new ImageApi(GetApiConfiguration()).apiImageDeletePublicImageDelete({
            bloburl: blobUri
        });
    };

    public static getDownloadUrl = (dto: BlobDto) => {
        return process.env.REACT_APP_API_URL + '/Image/downloadImage?bloburl=' + dto.relativeUri;
    }
}